import React from 'react';
import { clsx } from 'clsx';

interface PriorityBadgeProps {
  priority: 'Low' | 'Medium' | 'High';
  className?: string;
}

export const PriorityBadge: React.FC<PriorityBadgeProps> = ({ priority, className }) => {
  const priorityStyles = {
    'Low': 'badge-low',
    'Medium': 'badge-medium',
    'High': 'badge-high',
  };

  return (
    <span className={clsx(
      'inline-flex justify-center items-center w-full px-5 py-1 rounded text-center text-xs font-medium',
      priorityStyles[priority],
      className
    )}>
      {priority}
    </span>
  );
};